import React, { useLayoutEffect, useRef, useState, useEffect, useMemo } from 'react';
import {
  Container,
  Content,
  ContentWrapper,
  ContentWriteTime,
  Input,
  InputForm,
  InputWrapper,
  Label,
  List,
  ListItem,
  ListWrapper,
  Nav,
  CheerCount,
  SubmitButton,
  UserRow,
  Wrapper,
  InputButtonWrap,
  UploadImageWrap,
  PreviewImage,
  PreviewLoading,
  PreviewImageCancel,
  ImageViewBackground,
  CloseButton,
  PowerChatButton,
  CasterChatButton,
  AllButton,
  ParentContent,
  MessagePoint,
} from './styled';
import getUserProfileImageSrc from '../../../UserProfile';
import MatchCheerStore from '../../../../store/cheer';
import useUsersStore from '../../../../hooks/useUsersStore';
import useModalStore from 'hooks/useModalStore';
import { FormatUtil } from 'utils/formatUtil';
import { useInView } from 'react-intersection-observer';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import userProfileDef from 'images/sports/common/user-profile-def.png';
import { ScoreDetailService } from '../../../../common/services';
import Url from 'environment';
import PowerChatInput from './powerChatInput';
import PowerChatCarousel from './powerChatCarousel';
import ActionLayer from './actionLayer';
import { NamedCommunityService } from 'services/named';
import { Link, useLocation } from 'react-router-dom';
import champIcon from 'images/sports/common/ic-champ.svg';
import { Constants } from 'environment';
import ReCAPTCHA from 'react-google-recaptcha';

const sportTypeToId = {
  soccer: 1,
  baseball: 2,
  basketball: 3,
  volleyball: 4,
  hockey: 5,
  starcraft: 6,
  football: 7,
  lol: 9,
};

const IS_VIEW_ALL_CHEER = 'isViewAllCheer';

const Cheer = (props) => {
  const { sportsType, detail } = props;
  const location = useLocation();
  let { id } = useParams();
  const {
    getCheerList,
    getCheerMore,
    postCheerComment,
    closeSocket,
    closeChampSocket,
    data,
    setRef,
    changeCurrentSlide,
    postCheerCommentReport,
    getCheerCommentReport,
    isAll,
    changeViewMode,
    deletePowerChat,
  } = MatchCheerStore();

  const sportsId = sportTypeToId[sportsType];
  const userStore = useUsersStore();
  const modalStore = useModalStore();

  const { getTeamData, cheerCount } = detail;

  const basePathname = useMemo(() => {
    const locationPathArray = location.pathname.split('/');
    return `/${locationPathArray[1]}/${locationPathArray[2]}/${locationPathArray[3]}`;
  }, [location]);

  const teams = useMemo(() => {
    if (!!getTeamData) {
      return getTeamData;
    } else {
      return {
        home: { id: 0, imgPath: '' },
        away: { id: 0, imgPath: '' },
      };
    }
  }, [getTeamData]);

  const scrollRef = useRef();
  const listRef = useRef();
  const [text, setText] = useState('');
  const [inViewRef, inView, entry] = useInView({
    threshold: 0,
    triggerOnce: false,
  });
  const [uploadImage, setUploadImage] = useState(null);
  const [imgUrl, setImgUrl] = useState('');
  const [viewImage, setViewImage] = useState('');
  const [viewChatInput, setViewChatInput] = useState(false);
  const [viewChat, setViewChat] = useState(false);
  const [viewUserAction, setViewUserAction] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ user: {} });
  const [blackList, setBlackList] = useState([]);
  const [isCasterChat, setCasterChat] = useState(false);
  const [animateChatId, setAnimateChatId] = useState(null);

  const recaptchaRef = React.useRef(null);

  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (recaptchaRef.current) {
        setIsReady(true);
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleRecaptchaVerify = async () => {
    if (!recaptchaRef.current || typeof recaptchaRef.current.executeAsync !== 'function') {
      console.warn('Recaptcha is not ready');
      return null;
    }

    try {
      recaptchaRef.current.reset();
      const token = await recaptchaRef.current.executeAsync();
      await new Promise((resolve) => setTimeout(resolve, 200)); // Wait briefly to ensure the token is fully processed before proceeding. This helps prevent "Uncaught (in promise) Timeout (B)" errors in some browsers or slow networks.
      return token;
    } catch (e) {
      console.error('reCAPTCHA failed:', e);
      return null;
    }
  };

  const onClickImageCancel = () => {
    setUploadImage(null);
    setImgUrl('');
  };

  const uploadImageWithRecaptcha = async (file) => {
    const maxSize = 1024 * 1024 * 20;
    if (file.size > maxSize) {
      alert('업로드 가능한 용량을 초과하였습니다. (20MB)');
      return;
    }

    const token = await handleRecaptchaVerify();
    if (!token) {
      alert('reCAPTCHA 인증에 실패했습니다.');
      return;
    }

    try {
      const response = await ScoreDetailService.cheerImageChange(file, token);

      const { code, data } = response;

      if (code === 200) {
        setImgUrl(data.image_path);
      } else {
        alert(response.message || '이미지 업로드 실패');
      }
    } catch (err) {
      console.error('Upload error:', err);
      alert('이미지 업로드 중 오류가 발생했습니다.');
    }
  };

  useEffect(() => {
    if (uploadImage) {
      if (userStore.data.id === null) {
        modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
        return;
      }
      uploadImageWithRecaptcha(uploadImage);
    }

    return () => {
      setImgUrl('');
    };
  }, [uploadImage]);

  useLayoutEffect(() => {
    if (!!scrollRef.current) {
      setRef(scrollRef.current);
    }
  }, [scrollRef.current]);

  useEffect(() => {
    userStore.getInfo().then((res) => {
      if (res) {
        getBlackList(userStore.data.id).then((res) => {
          getCheerList(id, sportsType, sportsId, 1).then(() => {
            setTimeout(() => {
              scrollRef.current.scrollTop = listRef.current.scrollHeight;
            }, 100);
          });
        });
      } else {
        getCheerList(id, sportsType, sportsId, 1).then(() => {
          setTimeout(() => {
            scrollRef.current.scrollTop = listRef.current.scrollHeight;
          }, 100);
        });
      }
    });

    return () => {
      closeSocket();
      closeChampSocket();
    };
  }, []);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === IS_VIEW_ALL_CHEER) {
        changeViewMode(event.newValue === 'true');
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const getBlackList = async (userId) => {
    await NamedCommunityService.getBlackList(userId).then((res) => {
      if (res.code === 200) {
        const blackIdList = [];
        res.data.list.map((item) => blackIdList.push(item.mb_id));
        setBlackList(blackIdList);
      }
    });
  };

  useEffect(() => {
    if (inView) {
      getCheerMore(scrollRef.current.scrollHeight);
    }
  }, [inView]);

  const onSubmit = async (event) => {
    event.preventDefault();
    if (text.length === 0) {
      alert('메세지 입력하세요.');
      return;
    }
    if (userStore.data.id === null) {
      const loggedIn = await userStore.getInfo();
      if (!loggedIn) {
        modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
        return;
      }
    }
    // if (!userStore.data.is_admin) {
    //   if (!userStore.data.certify.is_phone_certify) {
    //     modalStore.openAlertModal({
    //       message: '휴대폰 인증 후 사용이 가능 합니다.'
    //     });
    //     return;
    //   }
    // }

    if (window.sessionStorage.getItem('lastMessage') === text) {
      alert('반복된 메세지는 입력할 수 없습니다.');
      return;
    }

    const param = {
      content: text,
      device: 'WEB',
      homeAway: null,
      selectTeamId: null,
    };

    if (uploadImage) {
      param.imagePath = imgUrl;
    }

    if (isCasterChat) {
      param.casterType = 'caster';
      param.messageType = 'caster';
    }

    postCheerComment(param).then((res) => {
      if (res.status === 200) {
        setText('');
        setImgUrl('');
        setUploadImage(null);
        window.sessionStorage.setItem('lastMessage', text);
      } else {
        modalStore.openAlertModal({
          message: res.data.message,
        });
      }
    });
  };

  const viewSuperChatCarousel =
    data.powerChat.comments.length > 0 && (detail.gameStatus === 'READY' || detail.gameStatus === 'IN_PROGRESS');

  const onClickAll = () => {
    if (isAll) {
      alert('응원하기 모두보기가 비활성화 됩니다.');
    } else {
      alert('응원하기 모두보기가 활성화 됩니다.');
    }
    changeViewMode(!isAll);
  };

  const onClickParent = (parentId) => {
    if (!!document.getElementById(parentId)) {
      let offsetTop = document.getElementById(parentId).offsetTop - 200;
      if (viewSuperChatCarousel) {
        offsetTop -= 80;
      }
      scrollRef.current.scrollTop = offsetTop;

      setAnimateChatId(parentId);
      setTimeout(() => setAnimateChatId(null), 1500);
    }
  };

  return (
    <>
      {viewImage && <ImageView viewImage={viewImage} onClose={() => setViewImage('')} />}
      <Container>
        <Nav>
          응원하기
          {cheerCount >= 1 && <CheerCount>{FormatUtil.numberUnitConvert(cheerCount)}</CheerCount>}
        </Nav>
        <Wrapper>
          {viewSuperChatCarousel && (
            <PowerChatCarousel
              powerChat={data.powerChat}
              viewChat={viewChat}
              setViewChat={setViewChat}
              changeCurrentSlide={changeCurrentSlide}
              deletePowerChat={deletePowerChat}
            />
          )}
          <PowerChatInput
            viewChatInput={viewChatInput}
            setViewChatInput={setViewChatInput}
            postCheerComment={postCheerComment}
          />
          <ActionLayer
            view={viewUserAction}
            onClickClose={() => setViewUserAction(false)}
            selectedUser={selectedUser}
            postCheerComment={postCheerComment}
            getCheerCommentReport={getCheerCommentReport}
            postCheerCommentReport={postCheerCommentReport}
            report={data.report}
            getBlackList={getBlackList}
          />
          <ListWrapper
            ref={scrollRef}
            style={{
              height: data.powerChat.totalCount > 0 ? 'calc(100% - 80px)' : '100%',
              paddingTop: viewChat ? '66px' : '0',
            }}
          >
            <div ref={inViewRef} />
            <List ref={listRef}>
              {data.comments.map((value, key) => {
                if (blackList.includes(value.user_id)) return null;
                return (
                  <CheerItem
                    key={key}
                    value={value}
                    teams={teams}
                    setViewImage={setViewImage}
                    setViewUserAction={setViewUserAction}
                    setSelectedUser={setSelectedUser}
                    loginUserId={userStore.data.id}
                    basePathname={basePathname}
                    onClickParent={onClickParent}
                    animate={animateChatId === value.id}
                    champGameId={detail.champGameId}
                    sportsType={sportsType}
                  />
                );
              })}
            </List>
          </ListWrapper>
          <AllButton className={'all'} active={isAll} onClick={onClickAll} />
          <InputWrapper>
            <InputButtonWrap>
              <label className={'img_upload'}>
                <span>사진</span>
                <input
                  type={'file'}
                  multiple={true}
                  accept='image/*'
                  onChange={(e) => {
                    setUploadImage(e.target.files[0]);
                  }}
                />
              </label>
              <div style={{ display: 'none' }}>
                <ReCAPTCHA
                  ref={(el) => {
                    recaptchaRef.current = el;
                    setIsRecaptchaReady(!!el);
                  }}
                  sitekey='6LespmQrAAAAAJKfCUHeXSNM3qrlnZsg31FmfNg4'
                  size='invisible'
                  onErrored={() => {
                    console.error('ReCAPTCHA failed to load or execute');
                  }}
                />
              </div>

              <PowerChatButton onClick={() => setViewChatInput(true)}>
                <span>파워챗</span>
              </PowerChatButton>
              {userStore.data.id !== null && userStore.data.id.includes('caster_account') && (
                <CasterChatButton isActive={isCasterChat} onClick={() => setCasterChat(!isCasterChat)}>
                  캐스터
                </CasterChatButton>
              )}
            </InputButtonWrap>
            <UploadImageWrap isActive={imgUrl !== ''}>
              <PreviewLoading />
              {imgUrl && (
                <>
                  <PreviewImage imageUrl={`${Url.thumb}/100x100${imgUrl}`} />
                  <PreviewImageCancel onClick={onClickImageCancel} />
                </>
              )}
            </UploadImageWrap>
            <InputForm onSubmit={onSubmit}>
              <Label>
                <Input
                  type={'text'}
                  name={'cheerText'}
                  placeholder={'메세지를 입력하세요'}
                  autoComplete={'off'}
                  value={text}
                  onChange={(event) => setText(event.target.value)}
                  onFocus={() => (scrollRef.current.scrollTop = scrollRef.current.scrollHeight)}
                />
              </Label>
              <SubmitButton type={'submit'} isActive={text !== ''} />
            </InputForm>
          </InputWrapper>
        </Wrapper>
      </Container>
    </>
  );
};

const CheerItem = observer(
  ({
    value,
    setViewImage,
    setViewUserAction,
    setSelectedUser,
    loginUserId,
    basePathname,
    onClickParent,
    animate,
    sportsType,
    champGameId,
  }) => {
    const {
      profile_image_path,
      mb_nick,
      content,
      image_path,
      is_admin,
      is_jail,
      user_id,
      create_at,
      type,
      user,
      crime_type,
      nick_mark,
      message_type,
      differentGame,
      is_sports_analysis,
      parent_id,
      parent_mb_nick,
      parent_content,
      parent_image_path,
      isChamp,
      msg_point,
    } = value;

    const [viewBlind, setViewBlind] = useState(false);

    const formattedTime = moment(create_at).format('HH:mm');

    const userStore = useUsersStore();

    const userName = mb_nick;

    const isMe = useMemo(() => {
      return userStore.data.id === user_id;
    }, [userStore.data.id, user_id]);

    const profileImageSrc = getUserProfileImageSrc({
      admin: is_admin,
      jail: is_jail,
      type: type,
      profileImg: user.profile_img,
    });

    const nicknameColor = value?.config_chat_nickname_color || null;
    const textColor = value?.config_chat_text_color || null;

    return (
      <ListItem id={value.id}>
        <UserRow
          isMe={isMe}
          isChamp={!!isChamp}
          onClick={() => {
            if (loginUserId === user.user_id || !!isChamp) return;
            setViewUserAction(true);
            setSelectedUser(value);
          }}
        >
          <img
            className={'profile'}
            src={!!isChamp ? `${Url.champThumb}${profile_image_path}` : profileImageSrc}
            onError={(event) => {
              event.target.src = userProfileDef;
            }}
          />
          {isChamp && <img className={'champ'} src={champIcon} />}
          {is_sports_analysis && <span className={'analysis'}>[분석가]</span>}
          <span style={nicknameColor ? { color: nicknameColor } : {}} >{userName}</span>
          {(nick_mark === 'r' || nick_mark === 'f') && <em className={nick_mark} />}
        </UserRow>
        <ContentWrapper>
          <Content
            className={crime_type}
            isComment={!!parent_id}
            isMe={isMe}
            differentGame={differentGame}
            isImportImg={image_path !== null}
            type={is_admin && (type ? type : 'caster')}
            onClick={(e) => {
              e.stopPropagation();
              setViewBlind(!viewBlind);
            }}
            animate={animate}
            isChamp={!!isChamp}
          >
            {!!parent_id && (
              <ParentContent
                onClick={() => {
                  onClickParent(parent_id);
                }}
              >
                <span>{`@${parent_mb_nick}`}</span>
                <div className={'comment_content'}>
                  {!!parent_image_path && (
                    <img
                      src={
                        !!isChamp
                          ? `${Url.champThumb}${parent_image_path}?x=20&y=20`
                          : `${Url.thumb}/100x100${parent_image_path}`
                      }
                    />
                  )}
                  <p>{parent_content}</p>
                </div>
              </ParentContent>
            )}
            {crime_type === 'b' && !viewBlind ? (
              '*블라인드 처리된 채팅입니다.'
            ) : (
              <>
                {differentGame && <DifferentGame item={value} />}
                {image_path && (
                  <img
                    src={!!isChamp ? `${Url.champThumb}${image_path}` : `${Url.thumb}/100x100${image_path}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setViewImage(!!isChamp ? `${Url.champThumb}${image_path}` : `${Url.thumb}/origin${image_path}`);
                    }}
                  />
                )}
                <div className={'content'} style={textColor ? { color: textColor } : {}}>
                  {!!content &&
                    content.split(' ').map((text, key) => {
                      if (text.indexOf('▲') !== -1) {
                        return <em className={'up'} key={key}>{`${text.replace('▲', '')} `}</em>;
                      } else if (text.indexOf('▼') !== -1) {
                        return <em className={'down'} key={key}>{`${text.replace('▼', '')} `}</em>;
                      } else {
                        return `${text} `;
                      }
                    })}
                  {(message_type === 'ODDS' || message_type === 'LINEUP' || message_type === 'ANALYSIS') &&
                    !differentGame && (
                      <Link to={`${basePathname}/${message_type.toLowerCase()}`} onClick={(e) => e.stopPropagation()}>
                        확인하기
                      </Link>
                    )}
                  {!!isChamp && !!champGameId && (
                    <a href={`https://champscore.com/${sportsType}/${champGameId}`} target={'_blank'}>
                      챔프스코어
                    </a>
                  )}
                </div>
              </>
            )}
          </Content>
          {formattedTime && <ContentWriteTime>{formattedTime}</ContentWriteTime>}
        </ContentWrapper>
        <MessagePoint>{msg_point}</MessagePoint>
      </ListItem>
    );
  }
);

const ImageView = ({ viewImage = '', onClose }) => {
  const ref = useRef(null);
  const [isScroll, setIsScroll] = useState(false);

  return (
    <ImageViewBackground isScroll={isScroll} onClick={onClose}>
      <CloseButton onClick={onClose} />
      <img
        ref={ref}
        src={viewImage}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onLoad={(e) => {
          if (window.innerHeight < e.currentTarget.clientHeight) {
            setIsScroll(true);
          }
        }}
      />
    </ImageViewBackground>
  );
};

const DifferentGame = ({ item }) => {
  return (
    <a
      className={'game_score'}
      href={`/match/${item.sports_name}/${item.game_id}/stat`}
      onClick={(e) => e.stopPropagation()}
    >{`[${sportsNameKo(item.sports_name)}] ${item.home_name} ${item.home_score} - ${item.away_score} ${
      item.away_name
    }`}</a>
  );
};

const sportsNameKo = (enName) => {
  const nameMap = {
    soccer: '축구',
    baseball: '야구',
    basketball: '농구',
    volleyball: '배구',
    hockey: '하키',
    football: '미식축구',
  };
  return nameMap[enName];
};

export default Cheer;
